import type { ManagementCategoryId } from "./management-section-registry"

/**
 * i18n keys and English fallbacks for the Configuration category labels.
 *
 * Lives outside the component files so both the in-workspace setting picker
 * and the global search palette read the same labels (and so component files
 * keep exporting components only, per `react-refresh/only-export-components`).
 */
export const CATEGORY_LABEL_KEYS: Record<ManagementCategoryId, string> = {
  "data-indexing": "adminDashboard.workspace.categories.dataIndexing",
  "ai-models": "adminDashboard.workspace.categories.aiModels",
  agents: "adminDashboard.workspace.categories.agents",
  integrations: "adminDashboard.workspace.categories.integrations",
  communication: "adminDashboard.workspace.categories.communication",
  "product-features": "adminDashboard.workspace.categories.productFeatures",
  "access-audit": "adminDashboard.workspaceNavigation.areas.accessAudit",
}

export const CATEGORY_LABEL_DEFAULTS: Record<ManagementCategoryId, string> = {
  "data-indexing": "Data & indexing",
  "ai-models": "AI & models",
  agents: "Agents",
  integrations: "Integrations",
  communication: "Communication",
  "product-features": "Product features",
  "access-audit": "Access & audit",
}
